import { useMemo } from 'react';
import { sortSimpleObjectArray } from '../../helpers/helper';
import { ReadContractRole, ReadContractTypes, useGetContractsQuery } from '../gql/graphql.generated';
import { Contract, ContractRole } from './contracts.types';

export const useContracts = () => {
  const [{ data }, refetch] = useGetContractsQuery();

  const contracts = useMemo(() => {
    return (sortSimpleObjectArray(data?.readContracts || [], 'displayOrder') as ReadContractTypes[]).map(c =>
      gqlToContract(c)
    );
  }, [data]);

  return { contracts, refetch };
};

export const gqlToContract = (contract: ReadContractTypes): Contract => {
  let props: any = {};
  if (contract.properties) {
    props = JSON.parse(contract.properties);
  }
  return {
    id: contract.id,
    name: contract.name,
    active: !!contract.active,
    minHoursPerDay: contract.minHoursPerDay,
    maxHoursPerDay: contract.maxHoursPerDay,
    minHoursPerWeek: contract.minHoursPerWeek,
    maxHoursPerWeek: contract.maxHoursPerWeek,
    earliestStartTime: contract.earliestStartTime,
    latestEndTime: contract.latestEndTime,
    maxHoursPerShift: contract.maxHoursPerShift,
    maxDaysPerWeek: contract.maxDaysPerWeek,
    maxConsecutiveDays: contract.maxConsecutiveDays,
    displayOrder: contract.displayOrder,
    contractCode: props.ContractCode,
    mapToStandardId: props.MapToStandardId,
    overtimeAllowed: contract.overtimeAllowed,
    roles: (sortSimpleObjectArray(contract.roles ?? [], 'displayOrder') as ReadContractRole[])?.map(r =>
      gqlToContractRole(r)
    )
  };
};

export const gqlToContractRole = (role: ReadContractRole): ContractRole => {
  return {
    id: role.id,
    name: role.name,
    active: !!role.active,
    notes: role.notes,
    displayOrder: role.displayOrder
  };
};
